import Alpine from 'alpinejs';
import { Download } from './types';
import ModalStore from '@/stores/modal/modal';

export class VideoDownload {
    showPromo = true;
    MODAL_CLOSE_DELAY = 3000;
    videoEl = document.getElementById('video');
    streamRawId = this.videoEl?.getAttribute('data-videoid');

    startDownload({ url, quality }: Download): void {
        if (!url.includes('/users/upload')) {
            window.analytics_track_event('video', 'download', quality);

            const location = `/api/download/go?f=${encodeURIComponent(url)}&q=${quality}&id=${this.streamRawId}`;
            window.location.href = location;

            setTimeout(() => {
                const modalStore = Alpine.store('modal') as ModalStore | undefined;
                modalStore?.closeModal('video_download');
            }, this.MODAL_CLOSE_DELAY);
        } else {
            window.location.href = url;
        }
    }
}
